module.exports = __webpack_public_path__ + "img/hwdl14.b93e19ad.jpg";